/* ════════════════════════════════════════════════════════════════
   GAHRET — Theme JavaScript (Vanilla, portiert aus React-Prototyp)
   ════════════════════════════════════════════════════════════════ */
(function () {
  'use strict';

  /* ── BROWSER-SPRACH-WEICHE ──────────────────────────────────────
     Logik: Browser-Sprache Deutsch (de*)  → Deutsch (Denglisch-Content)
            alles andere                    → Englisch (/en)
     Greift nur beim ersten Besuch (cookie-geschützt), respektiert
     manuelle Sprachwahl und Suchmaschinen-Bots. Nur aktiv, wenn die
     jeweilige Sprache im Store veröffentlicht ist. */
  (function autoLocale() {
    var i18n = window.GAHRET_I18N;
    if (!i18n || !i18n.langs) return;
    // schon entschieden? (Cookie) → nichts tun
    if (document.cookie.indexOf('gahret_lang_set=') > -1) return;
    // Bots in Ruhe lassen
    if (/bot|crawl|spider|slurp|bing|google/i.test(navigator.userAgent)) return;

    var browser = (navigator.language || (navigator.languages && navigator.languages[0]) || 'de').slice(0, 2).toLowerCase();
    var target = (browser === 'de') ? 'de' : 'en';

    function setCookie() { document.cookie = 'gahret_lang_set=1;path=/;max-age=31536000;SameSite=Lax'; }

    // Zielsprache nicht verfügbar oder schon aktiv → nur Cookie setzen
    if (!i18n.langs[target] || i18n.current === target) { setCookie(); return; }

    setCookie();
    var base = i18n.langs[target];
    // aktuellen Pfad an die Zielsprache anhängen (root_url endet ohne / bzw. mit Sprachpräfix)
    window.location.replace(base);
  })();

  /* ── THEME SWITCHER (dark / girly) ──────────────────────────── */
  var SITE = document.getElementById('site');
  var STORAGE_KEY = 'gahret-theme';

  function applyTheme(name) {
    if (!SITE) return;
    if (name !== 'dark' && name !== 'girly') name = 'dark'; // white entfernt
    SITE.setAttribute('data-theme', name);
    try { localStorage.setItem(STORAGE_KEY, name); } catch (e) {}
    document.querySelectorAll('.tsw-btn').forEach(function (b) {
      b.classList.toggle('tsw-active', b.dataset.theme === name);
    });
    // theme-spezifische Hero-Texte ein-/ausblenden
    document.querySelectorAll('[data-theme-only]').forEach(function (el) {
      el.style.display = el.dataset.themeOnly === name ? '' : 'none';
    });
  }

  // gespeichertes Theme beim Laden anwenden (Default kommt aus dem Liquid-Attribut)
  try {
    var saved = localStorage.getItem(STORAGE_KEY);
    if (saved) applyTheme(saved);
    else if (SITE) applyTheme(SITE.getAttribute('data-theme') || 'dark');
  } catch (e) {}

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('.tsw-btn');
    if (btn && btn.dataset.theme) applyTheme(btn.dataset.theme);
  });

  /* ── SCROLL SHADOW NAV ──────────────────────────────────────── */
  var nav = document.querySelector('.nav');
  if (nav) {
    window.addEventListener('scroll', function () {
      nav.classList.toggle('nav-scrolled', window.scrollY > 30);
    }, { passive: true });
  }

  /* ── MOBILE MENU ────────────────────────────────────────────── */
  var burger = document.querySelector('.nav-burger');
  var drawer = document.querySelector('.mobile-menu');
  if (burger && drawer) {
    burger.addEventListener('click', function () { drawer.classList.toggle('open'); });
    drawer.addEventListener('click', function (e) { if (e.target.tagName === 'A') drawer.classList.remove('open'); });
  }

  /* ── MASCOTS (Morti / Kuro) ─────────────────────────────────── */
  var BAT_MSGS = ['BOO! ⛧', 'hehe~', '*flap*', '⛧ hi ⛧'];
  var CAT_MSGS = ['nya ♡', '✦ meow', 'uwu ♡', '*purr* ♡'];
  function wireMascot(el, msgs) {
    if (!el) return;
    el.addEventListener('click', function () {
      if (el._busy) return;
      el._busy = true;
      el.classList.add('mascot-reacting');
      var b = document.createElement('div');
      b.className = 'mascot-bubble';
      b.textContent = msgs[Math.floor(Math.random() * msgs.length)];
      el.appendChild(b);
      setTimeout(function () {
        el.classList.remove('mascot-reacting');
        if (b.parentNode) b.parentNode.removeChild(b);
        el._busy = false;
      }, 1600);
    });
  }
  wireMascot(document.querySelector('.mascot-bat'), BAT_MSGS);
  wireMascot(document.querySelector('.mascot-cat'), CAT_MSGS);

  /* ── PARTICLES (dark) / SPARKLES (girly) ────────────────────── */
  document.querySelectorAll('[data-fx="particles"]').forEach(function (layer) {
    var chars = ['✦', '◆', '▪', '◇', '✧', '▫', '◈', '▸'];
    var pts = [[8,25,8,'float1',0],[88,18,10,'float2',.5],[15,70,7,'float3',1],[76,65,9,'float1',1.5],
      [50,88,8,'float2',.8],[93,45,7,'float3',.3],[5,48,10,'float1',2],[62,10,8,'float2',.7],
      [33,60,6,'float3',1.3],[70,30,9,'float1',.9]];
    pts.forEach(function (p, i) {
      var s = document.createElement('span');
      s.className = 'fx-particle';
      s.textContent = chars[i % chars.length];
      s.style.cssText = 'left:' + p[0] + '%;top:' + p[1] + '%;font-size:' + p[2] + 'px;animation:' + p[3] + ' ' + (3.5 + i * .35) + 's ease-in-out infinite;animation-delay:' + p[4] + 's';
      layer.appendChild(s);
    });
  });
  document.querySelectorAll('[data-fx="sparkles"]').forEach(function (layer) {
    var sp = [[10,20,0],[86,14,.5],[20,76,1],[72,72,1.5],[50,10,.8],[93,50,.3],
      [6,55,2],[62,86,.7],[40,5,1.2],[78,38,.9],[25,40,.4],[55,60,1.8]];
    sp.forEach(function (p, i) {
      var s = document.createElement('span');
      s.className = 'fx-sparkle';
      s.textContent = '✦';
      s.style.cssText = 'left:' + p[0] + '%;top:' + p[1] + '%;animation:sparkle ' + (1.8 + (i % 3) * .5) + 's ease-in-out infinite;animation-delay:' + p[2] + 's';
      layer.appendChild(s);
    });
  });

  /* ── NEWSLETTER (UX-Feedback, Shopify-Form submittet normal) ── */
  // Bestätigung übernimmt Shopify (customer form). Hier nur visuelles Feedback bei JS-Fallback.

  /* ── AJAX ADD TO CART ───────────────────────────────────────── */
  function updateCartCount(count) {
    document.querySelectorAll('[data-cart-count]').forEach(function (el) {
      var txt = el.textContent.replace(/\(\d+\)/, '(' + count + ')');
      el.textContent = txt.indexOf('(') > -1 ? txt : el.textContent + ' (' + count + ')';
    });
  }

  document.addEventListener('submit', function (e) {
    var form = e.target.closest('form[action$="/cart/add"], form[data-ajax-cart]');
    if (!form) return;
    // Custom-Formulare (mit Datei-Upload/Properties) nativ absenden, nicht per AJAX.
    if (form.hasAttribute('data-native-cart')) return;
    e.preventDefault();
    var btn = form.querySelector('[type="submit"], .add-btn');
    var orig = btn ? btn.textContent : '';
    if (btn) { btn.disabled = true; btn.textContent = '...'; }

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: form.querySelector('[name="id"]').value, quantity: 1 })
    })
      .then(function (r) { return r.json(); })
      .then(function () { return fetch('/cart.js').then(function (r) { return r.json(); }); })
      .then(function (cart) {
        updateCartCount(cart.item_count);
        if (btn) {
          var girly = SITE && SITE.getAttribute('data-theme') === 'girly';
          btn.textContent = girly ? '✓ ADDED ♡' : '✓ IN WARENKORB';
          setTimeout(function () { btn.textContent = orig; btn.disabled = false; }, 1800);
        }
      })
      .catch(function () {
        if (btn) { btn.textContent = orig; btn.disabled = false; }
        window.location.href = '/cart';
      });
  });
})();
